export default __webpack_public_path__ + "static/media/001-pirate-3.51d0dd6a.png";